/**
 * パスワード関連メソッド
 */
export default class PasswordUtils {
  /** パスワード最低長 */
  private static PASSWORD_MIN_LENGTH = 8

  /** 使用可能文字 */
  private static ENABLE_CHARACTERS = /^[a-zA-Z0-9]+$/

  /** 必須文字群 */
  private static REQUIRED_CHARACTERS_LIST = [
    // アルファベット
    /[a-zA-Z]/,
    // 数字
    /[0-9]/,
  ]

  /**
   * 有効なパスワード文字列かを判定する
   *
   * @param password パスワード
   * @returns 有効時：null 無効時：エラーメッセージ
   */
  public static checkPasswordEnabled(password: string): string | null {
    if (!this.ENABLE_CHARACTERS.test(password)) {
      return 'パスワードには半角のアルファベット、数字のみ使用できます'
    }

    if (!this.hasRequiredCharacters(password)) {
      return 'パスワードにはアルファベットと数字の両方を使用してください'
    }

    if (password.length < this.PASSWORD_MIN_LENGTH) {
      return `パスワードは${this.PASSWORD_MIN_LENGTH}文字以上で入力してください`
    }

    return null
  }

  /**
   * 必須文字を含むかの判定
   *
   * @param password パスワード
   * @returns 必須文字を含む場合はtrue、不正な場合はfalse
   */
  private static hasRequiredCharacters(password: string): boolean {
    // 必須文字群をループ
    for (let i = 0; i < this.REQUIRED_CHARACTERS_LIST.length; i++) {
      // 必須文字を含まない場合はfalseを返し終了
      if (!this.REQUIRED_CHARACTERS_LIST[i].test(password)) {
        return false
      }
    }

    // チェックを全て通過した場合はtrue
    return true
  }
}
